// lodash
import cloneDeep  from 'lodash.clonedeep';

export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const SET_ACTIVE_FORM = 'SET_ACTIVE_FORM';
export const UPDATE_CURRENT_STATE = 'UPDATE_CURRENT_STATE';
// contact post
export const CHANGE_HEADER_TEXT = 'CHANGE_HEADER_TEXT';
export const TOGGLE_SHOW_ADDRESS = 'TOGGLE_SHOW_ADDRESS';
export const TOGGLE_SHOW_EMAIL = 'TOGGLE_SHOW_EMAIL';
export const TOGGLE_SHOW_PHONE = 'TOGGLE_SHOW_PHONE';
export const TOGGLE_SHOW_WEBSITE = 'TOGGLE_SHOW_WEBSITE';
// custom post
export const CHANGE_CUSTOM_AUTHOR = 'CHANGE_CUSTOM_AUTHOR';
export const CHANGE_CUSTOM_AUTHOR_TITLE = 'CHANGE_CUSTOM_AUTHOR_TITLE';
export const CHANGE_CUSTOM_BUTTON_LINK = 'CHANGE_CUSTOM_BUTTON_LINK';
export const CHANGE_CUSTOM_BUTTON_TEXT = 'CHANGE_CUSTOM_BUTTON_TEXT';
export const CHANGE_CUSTOM_COMMENT = 'CHANGE_CUSTOM_COMMENT';
export const CHANGE_CUSTOM_COMMENT_AUTHOR = 'CHANGE_CUSTOM_COMMENT_AUTHOR';
export const CHANGE_CUSTOM_COMMENT_AUTHOR_TITLE = 'CHANGE_CUSTOM_COMMENT_AUTHOR_TITLE';
export const CHANGE_CUSTOM_IMAGE = 'CHANGE_CUSTOM_IMAGE';
export const CHANGE_CUSTOM_MESSAGE = 'CHANGE_CUSTOM_MESSAGE';
export const CHANGE_CUSTOM_POST_NAME = 'CHANGE_CUSTOM_POST_NAME';
export const CREATE_CUSTOM_POST = 'CREATE_CUSTOM_POST';
export const DELETE_CUSTOM_POST = 'DELETE_CUSTOM_POST';
export const REMOVE_CUSTOM_IMAGE = 'REMOVE_CUSTOM_IMAGE';
export const SHOW_CUSTOM_BUTTON = 'SHOW_CUSTOM_BUTTON';
export const SHOW_CUSTOM_COMMENT = 'SHOW_CUSTOM_COMMENT';
export const SHOW_CUSTOM_MESSAGE = 'SHOW_CUSTOM_MESSAGE';
export const SHOW_CUSTOM_IMAGE = 'SHOW_CUSTOM_IMAGE';
export const TOGGLE_CUSTOM_AUTHOR = 'TOGGLE_CUSTOM_AUTHOR';
// event results post
export const CHANGE_EVENT_RESULTS_HEADER_TEXT = 'CHANGE_EVENT_RESULTS_HEADER_TEXT';
export const TOGGLE_SHOW_ROOM_IMAGES = 'TOGGLE_SHOW_ROOM_IMAGES';
// layout
export const CHANGE_ROOM = 'CHANGE_ROOM';
export const CHANGE_VIEW = 'CHANGE_VIEW';
export const REORDER_COMPONENTS = 'REORDER_COMPONENTS';
// leaderboard
export const CHANGE_LB_INITIAL = 'CHANGE_LB_INITIAL';
export const CHANGE_LB_LENGTH = 'CHANGE_LB_LENGTH';
export const CHANGE_LB_SETTINGS = 'CHANGE_LB_SETTINGS';
export const TOGGLE_LB_ALL_GROUPS_ALL_TIME = 'TOGGLE_LB_ALL_GROUPS_ALL_TIME';
export const TOGGLE_LB_ALL_GROUPS_LAST_30_DAYS = 'TOGGLE_LB_ALL_GROUPS_LAST_30_DAYS';
export const TOGGLE_LB_BY_GROUP_SIZE_ALL_TIME = 'TOGGLE_LB_BY_GROUP_SIZE_ALL_TIME';
export const TOGGLE_LB_BY_GROUP_SIZE_LAST_30_DAYS = 'TOGGLE_LB_BY_GROUP_SIZE_LAST_30_DAYS';
export const TOGGLE_SHOW_CURRENT_GROUP = 'TOGGLE_SHOW_CURRENT_GROUP';
// message post
export const CHANGE_MESSAGE_AUTHOR = 'CHANGE_MESSAGE_AUTHOR';
export const CHANGE_MESSAGE_BUTTON_TEXT = 'CHANGE_MESSAGE_BUTTON_TEXT';
export const CHANGE_MESSAGE_BUTTON_TYPE = 'CHANGE_MESSAGE_BUTTON_TYPE';
export const CHANGE_MESSAGE_GUIDE_TITLE = 'CHANGE_MESSAGE_GUIDE_TITLE';
export const CHANGE_MESSAGE_MULTI_LINK = 'CHANGE_MESSAGE_MULTI_LINK';
export const CHANGE_MESSAGE_SINGLE_LINK = 'CHANGE_MESSAGE_SINGLE_LINK';
export const TOGGLE_SHOW_MESSAGE_AUTHOR = 'TOGGLE_SHOW_MESSAGE_AUTHOR';
export const TOGGLE_SHOW_MESSAGE_BUTTON = 'TOGGLE_SHOW_MESSAGE_BUTTON';
// photo post
export const CHANGE_COMMENT_AUTHOR = 'CHANGE_COMMENT_AUTHOR';
export const CHANGE_GUIDE_TITLE = 'CHANGE_GUIDE_TITLE';
export const TOGGLE_SHOW_COMMENT = 'TOGGLE_SHOW_COMMENT';
export const TOGGLE_SHOW_COMMENT_AUTHOR = 'TOGGLE_SHOW_COMMENT_AUTHOR';
export const TOGGLE_SHOW_FACEBOOK_SHARE = 'TOGGLE_SHOW_FACEBOOK_SHARE';
export const TOGGLE_SHOW_SHARING = 'TOGGLE_SHOW_SHARING';
export const TOGGLE_SHOW_TWITTER_SHARE = 'TOGGLE_SHOW_TWITTER_SHARE';
export const UPDATE_TWEET = 'UPDATE_TWEET';
export const UPDATE_TWITTER_HANDLE = 'UPDATE_TWITTER_HANDLE';
// preview settings
export const CHANGE_DID_ESCAPE = 'CHANGE_DID_ESCAPE';
export const CHANGE_GROUP_TYPE = 'CHANGE_GROUP_TYPE';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
// room messaging
export const CHANGE_ROOM_MESSAGING = 'CHANGE_ROOM_MESSAGING';
// custom css
export const CHANGE_CUSTOM_CSS = 'CHANGE_CUSTOM_CSS';
// tip jar
export const CHANGE_TIP_JAR_GUIDE_TITLE = 'CHANGE_TIP_JAR_GUIDE_TITLE';
export const CHANGE_TIP_JAR_MESSAGE_HEADER = 'CHANGE_TIP_JAR_MESSAGE_HEADER';
export const CHANGE_TIP_JAR_MESSAGE_SUB_HEADER = 'CHANGE_TIP_JAR_MESSAGE_SUB_HEADER';
export const CHANGE_TIP_JAR_BUTTON_TEXT = 'CHANGE_TIP_JAR_BUTTON_TEXT';

// const widgets = JSON.parse(window.widgets);
// const widgets = window.widgets;

const initialState = {
  activeForm: 'Main',
  activeFormContext: undefined,
  didEscape: true,
  view: 'desktop',
  widgets: cloneDeep(window.widgets),
  widgetsCurrent: cloneDeep(window.widgets),
}
if (window.mode == 'builder') {
  const roomMessaging = cloneDeep(window.room_messaging);
  const rooms = Object.keys(roomMessaging);
  let activeRoom = 0;
  if (rooms.length > 1) {
    activeRoom = parseInt(rooms[1]);
  }
  initialState['activeRoom'] = activeRoom;
  initialState['groupType'] = 'single';
  initialState['language'] = window.language;
  initialState['languages'] = window.languages;
  initialState['lbSettings'] = cloneDeep(window.lb_settings);
  initialState['lbSettings_current'] = cloneDeep(window.lb_settings);
  initialState['posts'] = cloneDeep(window.custom_posts);
  initialState['posts_current'] = cloneDeep(window.custom_posts);
  initialState['roomMessaging'] = roomMessaging;
  initialState['roomMessaging_current'] = cloneDeep(window.room_messaging);
  initialState['snackBarOpen'] = false;
  initialState['snackBarText'] = "";
}

export const builderReducer = (state = initialState, action) => {

  switch (action.type) {

    case CLOSE_SNACKBAR:

      return {
        ...state,
        snackBarOpen: false,
        snackBarText: "",
      }

    case SET_ACTIVE_FORM:

      return {
        ...state,
        activeForm: action.payload.activeForm,
        activeFormContext: action.payload.activeFormContext,
      }

    case UPDATE_CURRENT_STATE:

      return {
        ...state,
        widgetsCurrent: cloneDeep(state.widgets),
        lbSettings_current: cloneDeep(state.lbSettings),
        posts: cloneDeep(state.posts),
        posts_current: cloneDeep(state.posts),
        roomMessaging_current: cloneDeep(state.roomMessaging),
      }
      
    // contact post

    case CHANGE_HEADER_TEXT:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          contact_post: {
            ...state.widgets.contact_post,
            header_text: {
              ...state.widgets.contact_post.header_text,
              [language]: action.payload.headerText,
            },
          }
        }
      }

      case TOGGLE_SHOW_ADDRESS:

        return {
          ...state,
          widgets: {
            ...state.widgets,
            contact_post: {
              ...state.widgets.contact_post,
              show_address: action.payload.isChecked,
            }
          }
        }

      case TOGGLE_SHOW_EMAIL:

        return {
          ...state,
          widgets: {
            ...state.widgets,
            contact_post: {
              ...state.widgets.contact_post,
              show_email: action.payload.isChecked,
            }
          }
        }

      case TOGGLE_SHOW_PHONE:

        return {
          ...state,
          widgets: {
            ...state.widgets,
            contact_post: {
              ...state.widgets.contact_post,
              show_phone: action.payload.isChecked,
            }
          }
        }

      case TOGGLE_SHOW_WEBSITE:

        return {
          ...state,
          widgets: {
            ...state.widgets,
            contact_post: {
              ...state.widgets.contact_post,
              show_link: action.payload.isChecked,
            }
          }
        }
  
    // custom post

    case CHANGE_CUSTOM_AUTHOR:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              author: action.payload.customAuthor,
              author_final: action.payload.customAuthor,
              author_name: state.widgets.author[action.payload.customAuthor + '_name'],
              author_image: state.widgets.author[action.payload.customAuthor + '_image'],
            }
          }
        }
      }

    case CHANGE_CUSTOM_AUTHOR_TITLE:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              ["author_title_" + state.language]: action.payload.customAuthorTitle,
            }
          }
        }
      }

    case CHANGE_CUSTOM_BUTTON_LINK:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              button_link: action.payload.customButtonLink,
            }
          }
        }
      }

    case CHANGE_CUSTOM_BUTTON_TEXT:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              ["button_text_" + state.language]: action.payload.customButtonText,
            }
          }
        }
      }

    case CHANGE_CUSTOM_COMMENT:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              ["comment_" + state.language]: action.payload.customComment,
            }
          }
        }
      }

    case CHANGE_CUSTOM_COMMENT_AUTHOR:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              comment_author: action.payload.customCommentAuthor,
              comment_author_final: action.payload.customCommentAuthor,
              comment_author_name: state.widgets.author[action.payload.customCommentAuthor + '_name'],
              comment_author_image: state.widgets.author[action.payload.customCommentAuthor + '_image'],
            }
          }
        }
      }

    case CHANGE_CUSTOM_COMMENT_AUTHOR_TITLE:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              ["comment_author_title_" + state.language]: action.payload.customCommentAuthorTitle,
            }
          }
        }
      }

    case CHANGE_CUSTOM_IMAGE:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              image_name: action.payload.imageName,
              image_url: action.payload.imageUrl,
              // image_file: action.payload.imageFile,
            }
          }
        }
      }

    case CHANGE_CUSTOM_MESSAGE:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              ["message_" + state.language]: action.payload.customMessage,
            }
          }
        }
      }

    case CHANGE_CUSTOM_POST_NAME:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            name: action.payload.customPostName,
          }
        },
        activeFormContext: {
          ...state.activeFormContext,
          name: action.payload.customPostName,
        }
      }

    case CREATE_CUSTOM_POST:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.newPostId]: action.payload.newPostObj,
        },
        activeForm: 'Custom',
        activeFormContext: action.payload.newPostObj,
      }

    case DELETE_CUSTOM_POST:
      let newPosts = cloneDeep(state.posts);
      let postId = action.payload.postId;
      if (postId.toString().substring(0, 3) != "new") {
        newPosts['delete_' + postId] = newPosts[postId];
      }
      delete newPosts[postId];

      return {
        ...state,
        posts: newPosts,
        activeForm: 'Main',
        activeFormContext: undefined,
        snackBarOpen: true,
        snackBarText: action.payload.snackBarText,
      }

    case REMOVE_CUSTOM_IMAGE:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              image_name: null,
              image_url: null,
            }
          }
        }
      }

    case SHOW_CUSTOM_BUTTON:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              show_button: action.payload.isChecked,
            }
          }
        }
      }

    case SHOW_CUSTOM_COMMENT:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              show_comment: action.payload.isChecked,
            }
          }
        }
      }

    case SHOW_CUSTOM_MESSAGE:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              show_message: action.payload.isChecked,
            }
          }
        }
      }

    case SHOW_CUSTOM_IMAGE:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              show_image: action.payload.isChecked,
            }
          }
        }
      }

    case TOGGLE_CUSTOM_AUTHOR:

      return {
        ...state,
        posts: {
          ...state.posts,
          [action.payload.postId]: {
            ...state.posts[action.payload.postId],
            properties: {
              ...state.posts[action.payload.postId]["properties"],
              show_author: action.payload.isChecked,
            }
          }
        }
      }

    // event results post

    case CHANGE_EVENT_RESULTS_HEADER_TEXT:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          event_results: {
            ...state.widgets.event_results,
            header_text: {
              ...state.widgets.event_results.header_text,
              [language]: action.payload.headerText,
            },
          }
        }
      }

    case TOGGLE_SHOW_ROOM_IMAGES:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          event_results: {
            ...state.widgets.event_results,
            show_room_images: action.payload.isChecked,
          }
        }
      }

    // layout

    case CHANGE_ROOM:
      
      return {
        ...state,
        activeRoom: action.payload.room,
        groupType: action.payload.groupType,
      }

    case CHANGE_VIEW:
      
      return {
        ...state,
        view: action.payload.view,
      }

    case REORDER_COMPONENTS:

      return {
        ...state,
        widgets: action.payload.newWidgets,
        posts: action.payload.newPosts,
      }
      
    // leaderboard

    case CHANGE_LB_INITIAL:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          leaderboard: {
            ...state.widgets.leaderboard,
            show_initial: action.payload.lbInitial,
          }
        }
      }

    case CHANGE_LB_LENGTH:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          leaderboard: {
            ...state.widgets.leaderboard,
            length: action.payload.lbLength,
          }
        }
      }

    case CHANGE_LB_SETTINGS:

      if (action.payload.settingsName == 'ranking_value_label') {

        return {
          ...state,
          lbSettings: {
            ...state.lbSettings,
            [action.payload.room]: {
              ...state.lbSettings[action.payload.room],
              [action.payload.settingsName]: {
                ...state.lbSettings[action.payload.room][action.payload.settingsName],
                [state.language]: action.payload.value,
              },
            }
          }
        }

      } else {

        return {
          ...state,
          lbSettings: {
            ...state.lbSettings,
            [action.payload.room]: {
              ...state.lbSettings[action.payload.room],
              [action.payload.settingsName]: action.payload.value,
            }
          }
        }

      }

    case TOGGLE_LB_ALL_GROUPS_ALL_TIME:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          leaderboard: {
            ...state.widgets.leaderboard,
            show_all_groups_all_time: action.payload.isChecked,
          }
        }
      }

    case TOGGLE_LB_ALL_GROUPS_LAST_30_DAYS:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          leaderboard: {
            ...state.widgets.leaderboard,
            show_all_groups_last_30_days: action.payload.isChecked,
          }
        }
      }

    case TOGGLE_LB_BY_GROUP_SIZE_ALL_TIME:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          leaderboard: {
            ...state.widgets.leaderboard,
            show_by_group_size_all_time: action.payload.isChecked,
          }
        }
      }

    case TOGGLE_LB_BY_GROUP_SIZE_LAST_30_DAYS:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          leaderboard: {
            ...state.widgets.leaderboard,
            show_by_group_size_last_30_days: action.payload.isChecked,
          }
        }
      }

    case TOGGLE_SHOW_CURRENT_GROUP:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          leaderboard: {
            ...state.widgets.leaderboard,
            show_current_group: action.payload.isChecked,
          }
        }
      }
    
    // message post

    case CHANGE_MESSAGE_AUTHOR:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          message_post: {
            ...state.widgets.message_post,
            author: action.payload.msgAuthor,
            author_final: action.payload.msgAuthor,
            author_name: state.widgets.author[action.payload.msgAuthor + '_name'],
            author_image: state.widgets.author[action.payload.msgAuthor + '_image'],
          }
        }
      }

    case CHANGE_MESSAGE_BUTTON_TEXT:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          message_post: {
            ...state.widgets.message_post,
            button_text: {
              ...state.widgets.message_post.button_text,
              [state.language]: action.payload.msgButtonText},
          }
        }
      }

      case CHANGE_MESSAGE_BUTTON_TYPE:

          return {
            ...state,
            widgets: {
              ...state.widgets,
              message_post: {
                ...state.widgets.message_post,
                button_type: action.payload.msgButtonType,
              }
            }
          }
    
    case CHANGE_MESSAGE_GUIDE_TITLE:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          message_post: {
            ...state.widgets.message_post,
            guide_title: {
              ...state.widgets.message_post.guide_title,
              [state.language]: action.payload.msgGuideTitle},
          }
        }
      }

    case CHANGE_MESSAGE_MULTI_LINK:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          message_post: {
            ...state.widgets.message_post,
            multi_links: {
              ...state.widgets.message_post.multi_links,
              [action.payload.reviewType]: {
                ...state.widgets.message_post.multi_links[action.payload.reviewType],
                link: action.payload.msgMultiLink,
              }
            },
          }
        }
      }

    case CHANGE_MESSAGE_SINGLE_LINK:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          message_post: {
            ...state.widgets.message_post,
            single_link: action.payload.msgSingleLink,
          }
        }
      }

    case TOGGLE_SHOW_MESSAGE_AUTHOR:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          message_post: {
            ...state.widgets.message_post,
            show_author: action.payload.isChecked,
          }
        }
      }

    case TOGGLE_SHOW_MESSAGE_BUTTON:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          message_post: {
            ...state.widgets.message_post,
            show_button: action.payload.isChecked,
          }
        }
      }

    // photo post

    case CHANGE_COMMENT_AUTHOR:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          photo_post: {
            ...state.widgets.photo_post,
            comment: {
              ...state.widgets.photo_post.comment,
              author: action.payload.commentAuthor,
              author_final: action.payload.commentAuthor,
              author_name: state.widgets.author[action.payload.commentAuthor + '_name'],
              author_image: state.widgets.author[action.payload.commentAuthor + '_image'],
            }
          }
        }
      }

    case CHANGE_GUIDE_TITLE:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          photo_post: {
            ...state.widgets.photo_post,
            comment: {
              ...state.widgets.photo_post.comment,
              guide_title: {
                ...state.widgets.photo_post.comment.guide_title,
                [state.language]: action.payload.guideTitle,
              },
            }
          }
        }
      }

    case TOGGLE_SHOW_COMMENT:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          photo_post: {
            ...state.widgets.photo_post,
            comment: {
              ...state.widgets.photo_post.comment,
              show: action.payload.showComment,
            }
          }
        }
      }

    case TOGGLE_SHOW_COMMENT_AUTHOR:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          photo_post: {
            ...state.widgets.photo_post,
            comment: {
              ...state.widgets.photo_post.comment,
              show_author: action.payload.showCommentAuthor,
            }
          }
        }
      }

    case TOGGLE_SHOW_FACEBOOK_SHARE:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          photo_post: {
            ...state.widgets.photo_post,
            sharing: {
              ...state.widgets.photo_post.sharing,
              show_facebook: action.payload.isChecked,
            }
          }
        }
      }

    case TOGGLE_SHOW_TWITTER_SHARE:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          photo_post: {
            ...state.widgets.photo_post,
            sharing: {
              ...state.widgets.photo_post.sharing,
              show_twitter: action.payload.isChecked,
            }
          }
        }
      }
        
    case TOGGLE_SHOW_SHARING:
      
      return {
        ...state,
        widgets: {
          ...state.widgets,
          photo_post: {
            ...state.widgets.photo_post,
            sharing: {
              ...state.widgets.photo_post.sharing,
              show: action.payload.isChecked,
            }
          }
        }
      }
        
    case UPDATE_TWEET:
      
      return {
        ...state,
        widgets: {
          ...state.widgets,
          photo_post: {
            ...state.widgets.photo_post,
            sharing: {
              ...state.widgets.photo_post.sharing,
              tweet: {
                ...state.widgets.photo_post.sharing.tweet,
                [language]: action.payload.tweet,
              },
            }
          }
        }
      }
        
    case UPDATE_TWITTER_HANDLE:
      
      return {
        ...state,
        widgets: {
          ...state.widgets,
          photo_post: {
            ...state.widgets.photo_post,
            sharing: {
              ...state.widgets.photo_post.sharing,
              twitter_handle: action.payload.twitterHandle,
            }
          }
        }
      }

    // preview settings

    case CHANGE_DID_ESCAPE:
      
      return {
        ...state,
        didEscape: action.payload.didEscape == 'true' ? true : false,
      }

    case CHANGE_GROUP_TYPE:
      
      return {
        ...state,
        groupType: action.payload.groupType,
      }

    case CHANGE_LANGUAGE:
      
      return {
        ...state,
        language: action.payload.language,
      }

    // room messaging

    case CHANGE_ROOM_MESSAGING:
      
      // return {
      //   ...state,
      //   roomMessaging: {
      //     ...state.roomMessaging,
      //     [action.payload.room]: {
      //       ...state.roomMessaging[action.payload.room],
      //       [action.payload.msgName]: action.payload.msgValue,
      //     }
      //   }
      // }
      
      return {
        ...state,
        roomMessaging: {
          ...state.roomMessaging,
          [action.payload.room]: {
            ...state.roomMessaging[action.payload.room],
            [state.language]: {
              ...state.roomMessaging[action.payload.room][state.language],
              [action.payload.msgName]: action.payload.msgValue,
            },
          }
        }
      }

    // tip jar

    case CHANGE_TIP_JAR_GUIDE_TITLE:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          tipjar_post: {
            ...state.widgets.tipjar_post,
            guide_title: {
              ...state.widgets.tipjar_post.guide_title,
              [state.language]: action.payload.guide_title,
            },
          }
        }
      }

    case CHANGE_TIP_JAR_MESSAGE_HEADER:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          tipjar_post: {
            ...state.widgets.tipjar_post,
            header: {
              ...state.widgets.tipjar_post.header,
              [state.language]: action.payload.header,
            },
          }
        }
      }

    case CHANGE_TIP_JAR_MESSAGE_SUB_HEADER:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          tipjar_post: {
            ...state.widgets.tipjar_post,
            subheader: {
              ...state.widgets.tipjar_post.subheader,
              [state.language]: action.payload.subheader,
            },
          }
        }
      }

    case CHANGE_TIP_JAR_BUTTON_TEXT:

      return {
        ...state,
        widgets: {
          ...state.widgets,
          tipjar_post: {
            ...state.widgets.tipjar_post,
            button_text: {
              ...state.widgets.tipjar_post.button_text,
              [state.language]: action.payload.button_text,
            },
          }
        }
      }
      
    case CHANGE_CUSTOM_CSS:
  
      return {
        ...state,
        widgets: {
          ...state.widgets,
          custom_css: action.payload.customCSS,
        }
      }
    
    default:
      return state
  }
}
